var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.688,
    height: 21.628,
    viewBox: "0 0 23.688 21.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add-a-photo",
    "data-name": "Icon material-add-a-photo",
    d: "M3.09,4.59V1.5H5.15V4.59h3.09V6.65H5.15v3.09H3.09V6.65H0V4.59Zm3.09,6.179V7.679h3.09V4.59h7.209l1.885,2.06h3.265a2.066,2.066,0,0,1,2.06,2.06V21.068a2.066,2.066,0,0,1-2.06,2.06H5.15a2.066,2.066,0,0,1-2.06-2.06v-10.3Zm7.209,9.269a5.15,5.15,0,1,0-5.15-5.15A5.151,5.151,0,0,0,13.389,20.038Zm-3.3-5.15a3.3,3.3,0,1,0,3.3-3.3A3.292,3.292,0,0,0,10.093,14.889Z",
    transform: "translate(0 -1.5)",
    fill: "#00242e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.9cd0b734fe2513938dbe906a1dedf7b0.svg";
export { ForwardRef as ReactComponent };